/**
 * /tenants/$slug/agents/protected-resources/$resource/custody — outbound credential custody for
 * one egress destination. Thin shim: prefetch the custody read, mount the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchResourceCustody } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentResourceCustodyPage } from "@/features/agents/pages/agent-resource-custody-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/protected-resources/$resource/custody")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.resourceCustody(context.tenant.id, params.resource),
      queryFn: () => fetchResourceCustody(context.tenant.id, params.resource),
    }),
  component: AgentResourceCustodyPage,
});
